document.addEventListener('DOMContentLoaded', function () {
  const grid = document.querySelector('[data-collection-products] .grid');
  if (!grid) return;

  const pageHandle = document.querySelector('[data-main]')?.className || '';
  if (!pageHandle.includes('masterclass') && !pageHandle.includes('babyaftryk')) return;

  const items = Array.from(grid.querySelectorAll('.product-grid-item[data-event-date]'));
  if (items.length === 0) return;

  items.sort(function (a, b) {
    const dateA = new Date(a.dataset.eventDate);
    const dateB = new Date(b.dataset.eventDate);
    if (isNaN(dateA)) return 1;
    if (isNaN(dateB)) return -1;
    return dateA - dateB;
  });

  items.forEach(item => grid.appendChild(item));
});